import { getUrl } from '../../../config';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from "react-router-dom";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // Import de l'icône Close
import CheckIcon from '@mui/icons-material/Check';

const ListBonsLivraison = (props) => {
    const [bls, setBls] = useState([]);
    const { id } = useParams();

    const fetchBls = async () => {
        try {
            const response = await axios.get(getUrl() + `/api/informations/bonsprofile/` + id);
            if (response.data.status === 'success') {
                setBls(response.data.data.bls);
            } else {
                console.error('Erreur lors de la récupération des bons de livraison: ', response.data.message);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchBls();
    }, []);

    return (
        <Box sx={{ paddingBottom: 6 }}>
            <Paper elevation={3} sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ color: '#ffffff' }} mb={5}>
                    Liste des Bons de Livraison
                </Typography>
                <TableContainer
                    component={Paper}
                    sx={{
                        maxHeight: 250,
                        '&::-webkit-scrollbar': {
                            width: '4px', // Largeur de la scrollbar
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#888', // Couleur assombrie de la scrollbar
                            borderRadius: '10px', // Coins arrondis
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            backgroundColor: '#555', // Couleur plus foncée au survol
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: '#1B2635', // Couleur du fond de la scrollbar
                        },
                    }}
                >
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Bon de Livraison</TableCell>
                                <TableCell align="center">Commande ID</TableCell>
                                <TableCell align="center">Facture ID</TableCell>
                                <TableCell align="center">Client</TableCell>
                                <TableCell align="center">Édité</TableCell>
                                <TableCell align="center">Email Envoyé</TableCell>
                                <TableCell align="center">Date de Création</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {bls.map((row) => (
                                <TableRow
                                    key={row.id}
                                    hover sx={{ '& > *': { borderBottom: 'unset' } }}
                                >
                                    <TableCell sx={{ fontSize: '0.7rem' }} align="center">{row.id}</TableCell>
                                    <TableCell sx={{ fontSize: '0.7rem' }} align="center">{row.commandeId || <CloseIcon sx={{ color: 'red' }} />}</TableCell>
                                    <TableCell sx={{ fontSize: '0.7rem' }} align="center">{row.factureId || <CloseIcon sx={{ color: 'red' }} />}</TableCell>
                                    <TableCell sx={{ fontSize: '0.7rem' }} align="center">{row.clientName}</TableCell>
                                    <TableCell sx={{ fontSize: '0.7rem' }} align="center">{row.edited ? <CheckIcon sx={{ color: 'green' }} />: <CloseIcon sx={{ color: 'red' }} />}</TableCell>
                                    <TableCell sx={{ fontSize: '0.7rem' }} align="center">{row.mail ? <CheckIcon sx={{ color: 'green' }} /> : <CloseIcon sx={{ color: 'red' }} />}</TableCell>
                                    <TableCell sx={{ fontSize: '0.7rem' }} align="center">{row.created}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
};

export default ListBonsLivraison;